import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  public URLServeImg = "https://tiagoguim.bitsenior.com.br/api/view/courses/";
  public URLServe = "https://tiagoguim.bitsenior.com.br/api/view/";

  constructor() { }


  getURL() {
    return this.URLServe;
  }

  getURLServe(name: string) {
    return this.URLServe + name + ".php";
  }
}
